import React from 'react';
import classNames from 'classnames';

import LayoutComposer from '../LayoutComposer';
import LayoutWrapperAccountSettingsSideNav from './LayoutWrapperAccountSettingsSideNav';

import css from './LayoutSideNavigation.module.css';
import DashboardSideNav from './DashboardSideNav';

/**
 * Commonly used layout
 *
 * @component
 * @param {Object} props
 * @param {string?} props.className add more style rules in addition to component's own css.root
 * @param {string?} props.rootClassName overwrite components own css.root
 * @param {string?} props.containerClassName overwrite components own css.container
 * @param {string?} props.mainColumnClassName add more style rules in addition to css.main
 * @param {string?} props.sideNavClassName add more style rules in addition to css.sideNav
 * @param {ReactNode} props.children
 * @param {ReactNode} props.topbar
 * @param {ReactNode?} props.sideNav
 * @param {ReactNode?} props.footer
 * @param {boolean?} props.useAccountSettingsNav
 * @param {string?} props.currentPage
 * @returns {JSX.Element} LayoutComposer that expects children to be a function.
 */
const LayoutSideNavigation = props => {
  const {
    className,
    rootClassName,
    containerClassName,
    mainColumnClassName,
    sideNavClassName,
    children,
    topbar: topbarContent,
    footer: footerContent,
    sideNav: sideNavContent,
    useAccountSettingsNav,
    useDashboardSideNav,
    currentPage,
    isProfilePage,
    currentUser,
    profileListing,
    isOnboardingForm = false,
    ...rest
  } = props;

  const classes = classNames(rootClassName || css.root, className);
  const containerClasses = containerClassName || css.container;

  // TODO: since responsiveAreas are still experimental,
  //       we don't separate "aside" through layoutComposer
  const layoutAreas = `
    topbar
    main
    footer
  `;

  return (
    <LayoutComposer areas={layoutAreas} className={classes} {...rest}>
      {layoutProps => {
        const { Topbar, Main, Footer } = layoutProps;
        return (
          <>
            <Topbar as="header" className={css.topbar}>
              {topbarContent}
            </Topbar>
            <Main as="div" className={containerClasses}>
              {(sideNavContent || useAccountSettingsNav || useDashboardSideNav) && !isOnboardingForm ? (
                <aside className={classNames(css.sideNav, sideNavClassName)}>
                  {useAccountSettingsNav ? (
                    <LayoutWrapperAccountSettingsSideNav currentPage={currentPage} currentUser={currentUser} />
                  ) : useDashboardSideNav ?
                    <DashboardSideNav currentPage={currentPage} currentUser={currentUser} profileListing={profileListing} />
                  : null}
                  {sideNavContent}
                </aside>
              ) : null}
              <main className={classNames((isProfilePage ? css.mainProfilePage : css.main), mainColumnClassName)}>{children}</main>
            </Main>
            <Footer>{footerContent}</Footer>
          </>
        );
      }}
    </LayoutComposer>
  );
};

export default LayoutSideNavigation;
